// src/App.js
import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes ,Outlet  } from 'react-router-dom';
import Dashboard from './components/Dashboard/Dashboard';
import AddLicense from './components/Dashboard/AddLicense';
import EditLicense from './components/Dashboard/EditLicense';
import AddEmployee from './components/Dashboard/AddEmployee';
import EditEmployee from './components/Dashboard/EditEmployee';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Login from './components/auth/Login';
import Home from './components/auth/Home';
import { UserAuthContextProvider } from './contexts/authContext';

function App() {
  
  const Openlayout = () => {
    return (
      <>
        <Outlet />
      </>
    );
  };
  return (
    <UserAuthContextProvider>
    <Router>
      <Routes>
        <Route path="/" element={<Openlayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
          </Route>
       
        <Route path="/dashboard" element={<ProtectedRoute> <Dashboard /> </ProtectedRoute>} />
        <Route path="/dashboard/add-license" element={<ProtectedRoute> <AddLicense /> </ProtectedRoute>} />
        <Route path="/dashboard/edit-license/:id" element={<ProtectedRoute> <EditLicense /> </ProtectedRoute>} />
        <Route path="/dashboard/add-employee" element={<ProtectedRoute> <AddEmployee /> </ProtectedRoute>} />
        <Route path="/dashboard/edit-employee/:id" element={<ProtectedRoute> <EditEmployee /> </ProtectedRoute>} />
      </Routes>
    </Router>
    </UserAuthContextProvider>
  );
}

export default App;
